<div class="goal-detail" *ngIf="row as r">
  <!-- Hero -->
  <div class="gd-head">
    <div class="gd-head-text">
      <span class="gd-cat" *ngIf="category" [style.color]="category.color"><i [class]="category.icon"></i> {{ category.name }}</span>
      <h2>{{ r.epic.title }}</h2>
      <span class="gd-team" *ngIf="r.epic.origin === 'proposed'">
        <i class="fa-solid fa-lightbulb"></i> Iniciativa del equipo interno de TI
      </span>
    </div>
    <span class="gd-status" [style.background]="EPIC_STATUS_META[r.status].color">
      <i [class]="EPIC_STATUS_META[r.status].icon"></i> {{ EPIC_STATUS_META[r.status].label }}
    </span>
  </div>

  <!-- Avance real: derivado de las tareas, no declarado -->
  <div class="gd-work" *ngIf="r.taskCount">
    <div class="gd-work-top">
      <span class="gd-work-lbl"><i class="fa-solid fa-diagram-project" [style.color]="accent"></i> Avance del trabajo</span>
      <span class="gd-work-num">{{ r.doneCount }}/{{ r.taskCount }} tareas · {{ progress }}%</span>
    </div>
    <div class="gd-work-bar">
      <div class="gd-work-fill" [style.width.%]="progress" [style.background]="accent"></div>
    </div>
    <div class="gd-work-chips">
      <span class="gd-chip" *ngIf="r.points"><i class="fa-solid fa-weight-hanging"></i> {{ r.points }} pts de esfuerzo</span>
      <span class="gd-chip" *ngIf="durationLabel"><i class="fa-regular fa-clock"></i> {{ durationLabel }} de duración real</span>
      <span class="gd-chip" *ngFor="let p of r.epic.areas" [style.background]="p.color + '1a'" [style.color]="p.color">
        <i class="fa-solid fa-code-branch"></i> {{ p.name }}
      </span>
    </div>
  </div>

  <!-- Lead: qué aporta -->
  <div class="gd-lead" *ngIf="r.epic.value" [style.border-left-color]="accent">
    <span class="gd-lead-label">Qué aporta</span>
    <p>{{ r.epic.value }}</p>
  </div>

  <!-- Estimación de desarrollo (tiempo + inversión equivalente de agencia) -->
  <div class="gd-estimate" *ngIf="r.epic.estimate as e">
    <div class="gd-est-item">
      <span class="gd-est-label"><i class="fa-regular fa-clock"></i> Tiempo estimado</span>
      <span class="gd-est-value">{{ e.time }}</span>
    </div>
    <div class="gd-est-item">
      <span class="gd-est-label"><i class="fa-solid fa-coins"></i> Inversión equivalente</span>
      <span class="gd-est-value">{{ e.cost }}</span>
    </div>
    <p class="gd-est-basis" *ngIf="e.basis">{{ e.basis }}</p>
  </div>

  <!-- Elementos de valor -->
  <div class="gd-block" *ngIf="r.epic.valueElements?.length">
    <span class="gd-label"><i class="fa-solid fa-circle-check" [style.color]="accent"></i> Elementos de valor</span>
    <ul class="gd-checklist">
      <li *ngFor="let v of r.epic.valueElements">
        <i class="fa-solid fa-check" [style.color]="accent"></i>
        <span>{{ v }}</span>
      </li>
    </ul>
  </div>

  <!-- Métricas propuestas -->
  <div class="gd-block" *ngIf="r.epic.metrics?.length">
    <span class="gd-label"><i class="fa-solid fa-chart-line" [style.color]="accent"></i> {{ r.status === 'achieved' ? 'Métricas de impacto' : 'Métricas propuestas' }}</span>
    <div class="gd-metrics">
      <div class="gd-metric" *ngFor="let m of r.epic.metrics" [style.border-top-color]="accent">
        <i class="fa-solid fa-gauge-high" [style.color]="accent"></i>
        <span>{{ m }}</span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="gd-foot">
    <span class="gd-date" [class.muted]="!r.epic.date">
      <i class="fa-regular fa-calendar"></i> {{ r.epic.date ? 'Objetivo: ' + r.epic.date : 'Sin fecha objetivo (propuesta)' }}
    </span>
    <div class="gd-links" *ngIf="r.epic.links?.length">
      <span class="gd-link" *ngFor="let l of r.epic.links" [title]="l.ref"><i [class]="linkIcon(l)"></i>{{ l.label }}</span>
    </div>
  </div>
</div>
